import { customAccessFunction } from 'charts/common/access';
import { AnalyticsTranslationKeys } from 'intl/keys';
import { useProcessesWithField } from 'charts/common/useProcessesWithField';
import { useCallback, useMemo } from 'react';
import { useProcesses } from 'store/process';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import {
  ChartType,
  IssueChart,
} from 'shared/types/analytics';
import { EMPTY_VALUES_AND_LABELS, useGetChart } from '../common/hooks';
import { mapValuesAndLabels } from '../model/mapSeriesToRawData';
import { IssueChartContext, useIssueChartFilters } from 'charts/common/issueChartFilters';

export function useImpact(): IssueChartContext {
  const processesWithImpact = useProcessesWithField(
    IssueFieldNames.impact
  );
  const access = useCallback(() => {
    return Boolean(processesWithImpact.length);
  }, [processesWithImpact]);
  // The filters offer all the user's processes, not only those with the chart's field.
  const { processes } = useProcesses();
  const filters = useIssueChartFilters({ chart: IssueChart.impact, processes });
  const additionalParams = useMemo(
    () => ({
      visibleProcesses: processesWithImpact.map((process) => process._id),
    }),
    [processesWithImpact]
  );
  const { series, loading, load, reload, updatedAt } =
    useGetChart({ chart: IssueChart.impact, filters, additionalParams, initialSeries: EMPTY_VALUES_AND_LABELS });

  const rawData = useMemo(() => mapValuesAndLabels(series), [series]);

  return {
    filters,
    titleId: AnalyticsTranslationKeys.chart,
    chartType: ChartType.donut,
    canAccess: customAccessFunction(access),
    loading: !filters || loading,
    load,
    forceUpdate: reload,
    updatedAt: (): number => updatedAt,
    rawData,
  };
}
